import { CallState } from '../../../features/call/call.types';

export const phoneCallStates = [
  CallState.PhoneCallInitializing,
  CallState.PhoneCallRinging,
  CallState.PhoneCallInProgress,
  CallState.PhoneCallLeavingAfterError,
  CallState.PhoneCallLeaving,
];

export const getIsPhoneCall = (callState: CallState): boolean =>
  phoneCallStates.includes(callState);
